import type { TFunction } from 'i18next';

// Server messages (ShoppingCart.cs / ShoppingCartEditQuantityCommand.cs) are
// English; map the ones users actually hit to translated text.
export const localizeServerError = (message: string, t: TFunction): string =>
  /does not have enough stock/i.test(message)
    ? t('productActions.notEnoughStock')
    : message;
